import React, { FC, ReactNode } from 'react';

import { Box, Typography } from '@material-ui/core';

import { getIn, useFormikContext } from 'formik';
import CustomDateField from './custom-date-field';

type Props = {
  yearRound: 'floor' | 'ceil';
  label: string | ReactNode;
  id: string;
  disabled?: boolean;
};

const FormCustomDateField: FC<Props> = ({ yearRound, label, id, disabled }) => {
  const { errors, values, setFieldError, setFieldValue } = useFormikContext();
  const error = getIn(errors, id);
  return (
    <Box flexDirection="column" display="flex">
      <Typography
        style={{ fontSize: 'small', textAlign: 'center' }}
        color="primary"
      >
        {error && <>{error}</>}
      </Typography>
      <CustomDateField
        yearRound={yearRound}
        onChange={(item) => setFieldValue(id, item)}
        onError={(error) => setFieldError(id, error)}
        label={label}
        id={id}
        value={getIn(values, id)}
        hasError={!!error}
        disabled={disabled}
      />
    </Box>
  );
};

export default FormCustomDateField;
